import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { CustomerAllByGroup, QueryOptions } from "./apiEcms.types";

const getCustomersAllByGroup = async (signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<{
    customers: CustomerAllByGroup[];
  }>("/customers/all-by-group", { signal });

  return data;
};

export const useGetCustomersAllByGroup = (options?: QueryOptions) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.CUSTOMERS_ALL_BY_GROUP, currentGroup],
    queryFn: ({ signal }) => getCustomersAllByGroup(signal),
    select: (data) => data.customers,
    enabled: options?.enabled,
  });
};
